
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createUpdatePersonaPersonalityCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UpdatePersonaPersonality extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdatePersonaPersonality';

    public constructor(public id: string, public personalityFieldId: string, public value: number) {
        super(UpdatePersonaPersonality.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: UpdatePersonaPersonality): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createUpdatePersonaPersonalityCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: UpdatePersonaPersonality): void => {
    const persona = state.personas.find((x) => x.id === action.id);

    const personalityField = persona.personalities.find(x => x.id == action.personalityFieldId);
    personalityField.value = action.value;
};

//@ts-ignore
registerMiddleware(UpdatePersonaPersonality.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdatePersonaPersonality.ACTION_TYPE, reducer);